import { TaskSaveModel } from "app/modules/task/entities/TaskSaveModel";

export class NewLeaveModel {
    public Employee: EmployeeLeaveModel;
    public NewLeave: LeaveModel;
    public NextTask: TaskSaveModel;
}

export class EmployeeLeaveModel {
    public EmployeeId?: number;
    public Name: string;
    public Surname: string;
    public EmployeeRef?: string;
    public Nic?: string;
    public Ss?: string;
    public HiringDate?: string;
    public ContractEndDate?: string;
    public Gender?: string;
    public BirthDate?: string;
    public Age?: string;
    public Urgent?: string;
    public WorkingHourPercent?: string;
    public Position?: string;
    public CompanyId?: number;
    public Directions: any;
}

export class LeaveModel {
    public leaveId?: number;
    public leaveDate?: string;
    public dischargeDate?: string;
    public leaveCommunication?: string;
    public dischargeCommunication?: string;
    public leaveType?: string;
    public relapse?: boolean;
    public leaveRef?: string;
    public noPhone?: boolean;
    public noAddress?: boolean;
    public accidentPlace?: number;
    public accidentLocation?: string;
    public medicoId?: number;
    public comments: string;
}
